<img src="assets/img/oval.svg" alt="" class="loading-icon">
